import { del, get, post } from "aws-amplify/api";
import { API_NAME_VELAVU, normalizePromiseError, operationToJSON } from "../util/amplify-utils";
export default class VelavuAPIAssetInventory {
    //This method returns an Inventory object describing an asset's inventory.
    //https://docs.velavu.com/#get-asset-inventory
    getAssetInventory(asset_id) {
        return normalizePromiseError(operationToJSON(get({
            apiName: API_NAME_VELAVU,
            path: `/assets/${asset_id}/inventory`,
        })));
    }
    //This method adds an item or 'child asset' to a parent asset.
    //https://docs.velavu.com/#add-an-item-to-asset-inventory
    addInventoryItem(asset_id, item_id) {
        return normalizePromiseError(operationToJSON(post({
            apiName: API_NAME_VELAVU,
            path: `/assets/${asset_id}/inventory/item/${item_id}`,
        })));
    }
    //This method removes an item or 'child asset' from a parent asset.
    //https://docs.velavu.com/#remove-an-item-from-asset-inventory
    removeInventoryItem(asset_id, item_id) {
        return normalizePromiseError(del({
            apiName: API_NAME_VELAVU,
            path: `/assets/${asset_id}/inventory/item/${item_id}`,
        }).response);
    }
}
//# sourceMappingURL=velavu-api-asset-inventory.js.map